import { render, staticRenderFns } from "./dimension-form-4.vue?vue&type=template&id=025bbe5e&scoped=true&"
import script from "./dimension-form-4.vue?vue&type=script&lang=ts&"
export * from "./dimension-form-4.vue?vue&type=script&lang=ts&"
import style0 from "./dimension-form-4.vue?vue&type=style&index=0&id=025bbe5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bbe5e",
  null
  
)

export default component.exports